import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { DialogData } from "../dialog-common/dialog-common.model";

@Component({
  selector: "app-dialog-confirm-delete",
  templateUrl: "./dialog-confirm-delete.component.html",
  styleUrls: ["./dialog-confirm-delete.component.scss"],
})
export class DialogConfirmDeleteComponent {
  constructor(
    public dialogRef: MatDialogRef<DialogConfirmDeleteComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {
    this.dialogRef.backdropClick().subscribe(() => this.cancel());

    this.dialogRef.keydownEvents().subscribe((event) => {
      if (event.key === "Escape") {
        this.cancel();
      }
    });
  }

  confirm(): void {
    this.dialogRef.close(this.data);
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
